import { render, staticRenderFns } from "./editor-test.vue?vue&type=template&id=4ae950c0"
import script from "./editor-test.vue?vue&type=script&lang=js"
export * from "./editor-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports